export const sharingProfileUsers = (state) => state.sharingProfileUsers
export const unSharingProfileUsers = (state) => state.unSharingProfileUsers

export const selectAllField = (state) => state.selectAllField
export const selectedUsers = (state) => state.selectedUsers